import Me from "./Me"
import Imagelist from './Imagelist';
import Titlebar from './Titlebar';
import Footer from './Footer';
import github from "../Images/github-white.png";
import gitlab from "../Images/gitlab.svg"
import Cv from './Cv';
import Socials from './Socials';

function Home() {
  const cv = [
    {
      company: "Universität Paderborn",
      description: "Linux Systemadministrator",
      status: "Vollzeit",
      time: "01.04.2025 - jetzt"
    }, 
    {
      company: "Universität Paderborn",
      description: "Linux Systemadministrator",
      status: "Studentische Hilfskraft",
      time: "01.01.2024 - 31.03.2025"
    },
    {
      company: "Universität Paderborn",
      description: "Systemadministrator / Techniker",
      status: "Studentische Hilfskraft",
      time: "01.07.2019 - 31.12.2023"
    }
  ]

  const images = [
    {
      path: github,
      link: "https://github.com/tgotowik"
    },
    {
      path: gitlab,
      link: "https://gitlab.com/tgotowik"
    }
  ]

  return (
    <div className='mainWrapper'>
      <Me />
      <Cv></Cv>
      <Socials></Socials>
      <Footer></Footer>
    </div>
  );
}

export default Home;